// Phaser side of touchEnlarge.mjs: scale a menu/modal up on phones.
//   enlargeForTouch(scene, layers, { x, y, w, h }, { overlay, fixed })
// layers  — a container at (0,0) whose children are in world coordinates (the modal pattern),
//           or several (a modal's tab / item / preview layers are siblings, not children); a
//           plain game object in the list (a standalone close button) gets the same transform
// box     — the panel's centre and size in world coordinates
// overlay — the full-screen dimmer inside the first layer; it is counter-scaled so it keeps
//           covering exactly the screen (a panel slid away from an edge would leave a strip)
// fixed   — the layers are pinned to the screen (setScrollFactor(0)): the view is 0,0
import { GAME_WIDTH, GAME_HEIGHT } from '../config.js';
import { isTouchDevice } from './isTouchDevice.js';
import { enlargeTransform } from './touchEnlarge.mjs';

export function canvasScale(scene) {
  const r = scene.game.canvas?.getBoundingClientRect?.();
  return r && r.width ? r.width / GAME_WIDTH : 1;
}

export function touchTransform(scene, box, { fixed = false } = {}) {
  const cam = scene.cameras.main;
  const view = fixed ? { ox: 0, oy: 0, W: GAME_WIDTH, H: GAME_HEIGHT }
    : { ox: cam.scrollX, oy: cam.scrollY, W: GAME_WIDTH, H: GAME_HEIGHT };
  return { t: enlargeTransform({ touch: isTouchDevice(), k: canvasScale(scene), box, view }), view };
}

/** Apply an enlarge transform to one more object (a layer built later, e.g. a sub-dialog). */
export function applyTouchTransform(obj, t) {
  if (!obj || t.scale === 1) return obj;
  obj.setScale((obj.scaleX ?? 1) * t.scale, (obj.scaleY ?? 1) * t.scale)
    .setPosition(obj.x * t.scale + t.x, obj.y * t.scale + t.y);
  return obj;
}

export function enlargeForTouch(scene, layers, box, { overlay = null, fixed = false } = {}) {
  const { t, view } = touchTransform(scene, box, { fixed });
  if (t.scale === 1) return t;
  for (const l of [].concat(layers)) applyTouchTransform(l, t);
  if (overlay) {
    overlay.setOrigin(0, 0).setScale(1 / t.scale)
      .setPosition((view.ox - t.x) / t.scale, (view.oy - t.y) / t.scale);
  }
  return t;
}
